/* eslint-disable radix */
/* eslint-disable id-length */
import {getQueryString} from '../utils/queryParsing';

const queryParams = [`q1`, `q2`, `q3`, `q4`];

const getParams = () => getQueryString();

const getLastCharacter = str => str.substring(str.length - 1);

const getLastQuestionParam = paramsObject => {
    const keys = Object.keys(paramsObject);

    return keys.slice(keys.length - 1).join();
};

const getSortedRelevantParams = () => {
    const params = getParams();

    return Object.keys(params)
        .filter(k => queryParams.includes(k))
        // eslint-disable-next-line
        .reduce((obj, k) => (obj[k] = params[k], obj), {});
};

const mapQuestionParamsToSortedArray = paramsObject => Object.keys(paramsObject)
    .map(p => parseInt(getLastCharacter(p)))
    .sort((a, b) => a > b ? -1 : 1);

const getAnswerBasenOnParams = paramsObject => Object.keys(paramsObject)
    .map((p, i) => i === 3 ? paramsObject[p].split(`,`) : paramsObject[p]);

const getQuestionsHistory = paramsObject => Object.keys(paramsObject)
    .map((p, i) => getQuestionId(params, i + 1));

const isDescendingOrder = paramsObject => {
    const questionIndexArray = mapQuestionParamsToSortedArray(paramsObject);
    const isDescending       = index => {
        if (questionIndexArray[index] && index >= questionIndexArray.length - 1) {
            return true;
        }
        if (questionIndexArray[index] - 1 === questionIndexArray[index + 1]) {
            return isDescending(index + 1);
        }

        return false;
    };

    return isDescending(0);
};

const isGivenParamSet = (param, args) => {
    return args.some(a => a === param);
}

const getQuestionId = (paramsObject, index) => `question-${paramsObject.q1}-${index}`;

const getAnimationPath = (paramsObject, index) => {
    if (index === 4) {
        return `/animations/${paramsObject.q1}/${paramsObject.q1}-q${index}-results.json`;
    }

    return `/animations/${paramsObject.q1}/${paramsObject.q1}-q${index}-q${index + 1}.json`;
};

const getAnimationLoopPath = (paramsObject, index) => {
    if (index === 4 || paramsObject.q1 === 'retirement') {
        return false;
    }

    return {path: `/animations/${paramsObject.q1}/${paramsObject.q1}-q${index + 1}-loop.json`};
};

const params              = getSortedRelevantParams();
const paramsAreDescending = isDescendingOrder(params);
const lastQuestionIndex = parseInt(getLastCharacter(getLastQuestionParam(params)));

const getPath = () => {
    if(isGivenParamSet(getParams().m, ['1', '2', '3', '4'])) {
        return `/q2`;
    }
    if (!paramsAreDescending) {
        return `/intro`;
    }
    return lastQuestionIndex === 4 ? `/results` : `/intro`;
};

const getAnswers = () => {
    if(isGivenParamSet(getParams().m, ['1', '2', '3', '4'])) {
        // eslint-disable-next-line
        switch(getParams().m) {
            case `1` :
                return [`family`];
            case `2` :
                return [`retirement`];
            case `3` :
                return [`empty_nester`];
            case `4` :
                return [`disability`];
        }
    }
    if (!paramsAreDescending) {
        return [];
    }

    return lastQuestionIndex === 4 ? getAnswerBasenOnParams(params) : []
};

const getCurrentQuestionId = () => {
    if(isGivenParamSet(getParams().m, ['1', '2', '3', '4'])) {
        // eslint-disable-next-line
        switch(getParams().m) {
            case `1` :
                return `question-family-1`;
            case `2` :
                return `question-retirement-1`;
            case `3` :
                return `question-empty_nester-1`;
            case `4` :
                return `question-disability-1`;
        }
    }
    if (!paramsAreDescending) {
        return `question-start`;
    }

    return lastQuestionIndex === 4 ? getQuestionId(params, parseInt(getLastCharacter(getLastQuestionParam(params)))) : `question-start`;
};

const getQuestionHistory = () => {
    if(isGivenParamSet(getParams().m, ['1', '2', '3', '4'])) {
        return [`question-start`];
    }
    if (!paramsAreDescending) {
        return [];
    }

    return lastQuestionIndex === 4 ? [`question-start`, ...getQuestionsHistory(params)] : [];
};

const getAnimationId = () => {
    if(isGivenParamSet(getParams().m, ['1', '2', '3', '4'])) {
        // eslint-disable-next-line
        switch (getQueryString().m) {
            case `1` :
                return `/animations/family/family-q1-q2.json`;
            case `2` :
                return `/animations/retirement/retirement-q1-q2.json`;
            case `3` :
                return `/animations/empty_nester/empty_nester-q1-q2.json`;
            case `4` :
                return `/animations/disability/disability-q1-q2.json`;
        }
    }
    if (!paramsAreDescending) {
        return `/animations/intro/intro-loading.json`;
    }

    return lastQuestionIndex === 4 ? getAnimationPath(params, parseInt(getLastCharacter(getLastQuestionParam(params)))) : `/animations/intro/intro-loading.json`;
};

const getAnimationLoop = () => {
    if(isGivenParamSet(getParams().m, ['1', '2', '3', '4'])) {
        // eslint-disable-next-line
        switch(getParams().m) {
            case `1` :
                return {path: `/animations/family/family-q2-loop.json`};
            case `2` :
                return {path: `/animations/retirement/retirement-q2-loop.json`};
            case `3` :
                return {path: `/animations/empty_nester/empty_nester-q2-loop.json`};
            case `4` :
                return false;
        }
    }
    if (!paramsAreDescending) {
        return false;
    }

    return lastQuestionIndex === 4 ? getAnimationLoopPath(params, parseInt(getLastCharacter(getLastQuestionParam(params)))) : false;
};

export {getPath, getAnswers, getCurrentQuestionId, getQuestionHistory, getAnimationId, getAnimationLoop};
